$(window).scroll(function () {
    $("div.parallax").css("background-position","50% " + ($(this).scrollTop() / 25) + "px");
});